export default defineComponent({
	props: {
		url: String
	},
	setup: async (props: any, ctx: any) => {

		let url = usePublicUrl(props.url)

		const svg: string = await fetch(url).then(res => res.text())
		const svgEl: any = new DOMParser().parseFromString(svg, "image/svg+xml").firstChild
		svgEl.attributes.fill.value = 'none'
		let svgAttrs: any = {}
		Array.from(svgEl.attributes).forEach((attr: any ) => {
			svgAttrs[attr.nodeName] = attr.nodeValue
		})
		Array.from(svgEl.children).forEach((child: any) => {
			child.attributes.fill.value = 'currentColor'
		})

		svgAttrs = {...svgAttrs, ...ctx.$attrs, innerHTML: svgEl.innerHTML }
		return {
			svgAttrs
		}
	},
	render() {
		return h('svg', this.svgAttrs)
	}
})
